import { MarketingPageShell } from "@/components/landing/MarketingPageShell"
import { LegalProse } from "@/components/landing/LegalProse"

export function MerchantAgreementPage() {
  return (
    <MarketingPageShell
      narrow
      eyebrow="Legal"
      title="Merchant agreement"
      description="Last updated: March 22, 2026."
      extra="Additional terms for merchants using Sqaleshop to sell to customers. Read alongside our Terms & Conditions and Privacy Policy."
    >
      <LegalProse>
        <section>
          <h2>1. Merchant relationship</h2>
          <p>
            When you use Sqaleshop to sell, you are the seller of record to your
            customers. Sqaleup Inc. provides software; we are not the seller of
            your goods or services unless expressly stated otherwise.
          </p>
        </section>
        <section>
          <h2>2. Store content</h2>
          <p>
            You are responsible for accurate descriptions, pricing,
            availability, compliance with consumer and product laws, and any
            taxes or duties that apply to your business.
          </p>
        </section>
        <section>
          <h2>3. Payments</h2>
          <p>
            Payment processing may be provided by third parties. Settlement
            timelines and fees depend on your payment configuration and provider
            terms.
          </p>
        </section>
        <section>
          <h2>4. Customer data</h2>
          <p>
            You must use customer information collected through your store only
            for lawful purposes (fulfillment, support, and marketing where
            permitted and consented). Do not resell customer lists obtained via
            Sqaleshop in violation of law or our policies.
          </p>
        </section>
        <section>
          <h2>5. Prohibited goods and conduct</h2>
          <p>
            You may not use Sqaleshop for illegal products, deceptive practices,
            or activity that harms buyers or the platform. We may suspend stores
            that violate this agreement or applicable law.
          </p>
        </section>
        <section>
          <h2>6. Support and SLAs</h2>
          <p>
            Support channels and response expectations depend on your plan.
            Custom agreements may define additional SLAs.
          </p>
        </section>
        <section>
          <h2>7. Contact</h2>
          <p>
            Merchant questions:{" "}
            <a
              className="text-[#451892] hover:underline"
              href="mailto:support@sqaleshop.com"
            >
              support@sqaleshop.com
            </a>
            .
          </p>
        </section>
      </LegalProse>
    </MarketingPageShell>
  )
}
